<script>
    const moment = require('moment');

    import {DATE_FORMAT} from '../const';
    import Vue from 'vue';
    import DateRangePicker from 'vue2-daterange-picker';
    import VueTranslate from 'vue-translate-plugin';
    import lang from '../services/lang';

    moment.locale(lang.current());

    Vue.use(VueTranslate)
    Vue.locales({
        "Apply": "Zastosuj",
        "Select dates": "Wybierz daty"
    });

    export default
    {
        extends: DateRangePicker,
        // components: {VueTranslate},
        props: {
            localeData: {
                type: Object,
                default: () => {
                    return {
                        firstDay: 1,
                        format: DATE_FORMAT,
                        applyLabel: 'Zastosuj',
                        cancelLabel: 'Anuluj',
                        weekLabel: 'W',
                        customRangeLabel: 'Custom Range',
                    };
                }
            },
            opens: {
                type: String,
                default: 'center'
            },
            ranges: {
                type: [Object, Boolean],
                default: false,
            },
            autoApply: {
                type: Boolean,
                default: true,
            },
            placeholder: {
                type: String,
                default: 'Wybierz daty',
            },
            placeholderSingleDate: {
                type: String,
                default: 'Wybierz date'
            },
            showDropdowns: {
                type: Boolean,
                default: false,
            }
        },
        mounted()
        {
            console.log(this.$translate);
        },
        computed:
        {
            rangeText()
            {
                if (!this.startText && this.singleDatePicker) {
                    return this.placeholderSingleDate;
                }

                if (!this.startText && !this.singleDatePicker) {
                    return this.placeholder;
                }

                let range = this.startText;

                if (!this.singleDatePicker) {
                    range += this.locale.separator + this.endText;
                }

                return range;
            }
        }
    }
</script>

<style lang="scss">
    @import './../../node_modules/vue2-daterange-picker/dist/vue2-daterange-picker.css';

    .daterangepicker .calendars.row {
        margin-left:0;
    }

    @media screen and (min-width: 540px) {
        /*.daterangepicker {*/
            /*!*min-width: 590px!important;*!*/
        /*}*/
    }
</style>


// WEBPACK FOOTER //
// DateRangePickerPl.vue?6ecd3212